import { EnumHelper } from "@utils/translator/enumHelper";

export const VISIT_TYPE_LABELS = {
  domestic_animals: "Animais Domésticos",
  environmental_education: "Educação Ambiental",
} as const;

export type VisitType = keyof typeof VISIT_TYPE_LABELS;

export const VisitTypeHelper = new EnumHelper(VISIT_TYPE_LABELS);

export const FILE_TYPE_LABELS = {
  form: "Formulário",
  photo_report: "Relatório Fotográfico",
} as const;

export type FileType = keyof typeof FILE_TYPE_LABELS;

export const FileTypeHelper = new EnumHelper(FILE_TYPE_LABELS);
